<xt-portal-header
  [name]="name$ | async"
  [email]="email$ | async"
  [acronym]="acronym$ | async"
  [partnerLogoUrl]="partnerLogoUrl$ | async"
  [emergencyButtonUrl]="selectEmergencyUrl$ | async"
  [isUserRolePatient]="isUserRolePatient$ | async"
  [isUserRoleProvider]="isUserRoleProvider$ | async"
  [isProfileActive]="pageActiveStyle"
  [hideSidenavMenu]="!hasVerifiedRole()"
  (openSidenavEvent)="onOpenSidenav()"
  (toggleMenuEvent)="toggleMenuEvent()"
/>

<mat-sidenav-container
  *transloco="let t"
  [class.no-show]="!hasVerifiedRole()"
  class="sidenav-container"
  autosize
>
  <xt-ui-kit-side-nav
    [navigationList]="navigationList$ | async"
    [navigationBottomList]="navigationBottomList"
    (navItemClicked)="action($event)"
    dataCy="portal.dashboard-shell.side-nav."
    #sidenav
  >
    <xt-ui-kit-page-layout
      class="dashboard-content"
      [noPadding]="noPaddingMode"
    >
      <xt-ui-kit-page-action-header class="header" />

      @if (isUserAccountTerminated$ | async) {
        <xt-portal-terminate-user-account-banner />
      }

      <router-outlet></router-outlet>
    </xt-ui-kit-page-layout>

    @if (partnerLogoUrl$ | async; as parnterLogo) {
      <div slot="sidenav-content">
        <img
          class="sidenav-logo"
          [class.minimized]="!sidenav.isExpanded"
          [src]="parnterLogo"
          alt="Partner Logo"
          loading="lazy"
          tabindex="0"
        />
      </div>
    }
  </xt-ui-kit-side-nav>
</mat-sidenav-container>
